import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getAssignmentAppsOptions } from "@/lib/data/react-query/matters/matter-task";
import type { AssignmentApp } from "@/lib/data/requests/matters/matter-task";
import type { DirectoryUser } from "@/lib/types";
import { buildMentionOptions } from "@/lib/utils/mentionUtils";

export function useAppMentionOptions(
  users: DirectoryUser[],
  enabled = true,
  retained: AssignmentApp[] = [],
) {
  const { data: apps } = useQuery(getAssignmentAppsOptions(enabled));
  const retainedKey = JSON.stringify(retained);
  return useMemo(() => {
    const current = enabled ? (apps ?? []) : [];
    const installedIds = new Set(current.map((app) => app.integrationAppId));
    const all = new Map(
      [...current, ...(enabled ? retained : [])].map((app) => [
        app.integrationAppId,
        app,
      ]),
    );
    return buildMentionOptions(users, [...all.values()]).map((option) => ({
      ...option,
      selectable:
        !option.id.startsWith("app:") || installedIds.has(option.id.slice(4)),
    }));
    // Retained metadata is a value projection, often constructed from the annotation collection.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users, apps, enabled, retainedKey]);
}
